export default "__VITE_ASSET__CQnVDPR7__"